import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { FilterDialogFormWrapperValues } from "./FilterDialogFormWrapper";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
import useBatches from "src/hooks/useBatches";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { useGetAllGeeksDoorUserQuery } from "src/services/UserServices";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";

type Props = {
  formikProps: FormikProps<FilterDialogFormWrapperValues>;
  onClose: () => void;
  handleReset: any;
};

const FilterDialogForm = ({ formikProps, onClose, handleReset }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur, handleSubmit } =
    formikProps;

  const StatusOptions = [
    {
      label: "PENDING",
      value: "PENDING",
    },
    {
      label: "APPROVED",
      value: "COMPLETED",
    },
  ];

  const { batches, isDataLoading } = useBatches();
  const { data, isLoading, isFetching } = useGetAllGeeksDoorUserQuery("");

  const memebersOptions = data?.data?.map((el: any) => {
    return {
      label: el?.firstName.concat(el?.lastName),
      value: el?._id,
    };
  });

  const batchOptions = batches?.map((el: any) => {
    return {
      label: el?.batchName,
      value: el?._id,
    };
  });

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Filters </div>
        <button
          type="button"
          className="hover:bg-hover text-red-700 font-medium"
          onClick={handleReset}
        >
          Reset Filters
        </button>
      </div>
      <div className="flex flex-col gap-3">
        {/* Next FollowUp Date */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Request Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="requestStartDate"
              value={values?.requestStartDate}
              onChange={(newValue) =>
                setFieldValue("requestStartDate", newValue)
              }
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="requestEndDate"
              value={values?.requestEndDate}
              onChange={(newValue) => setFieldValue("requestEndDate", newValue)}
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.requestStartDate || null}
            />
          </div>
        </div>
        {/* Inquiry Date */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Action Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="actionStartDate"
              value={values?.actionStartDate}
              onChange={(newValue) =>
                setFieldValue("actionStartDate", newValue)
              }
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="actionEndDate"
              value={values.actionEndDate}
              onChange={(newValue) => setFieldValue("actionEndDate", newValue)}
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.actionStartDate || null}
            />
          </div>
        </div>

        {/* status's */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark mt-4">
          Status
        </div>
        <div className="grid grid-cols-2 gap-6 items-end">
          <div>
            <ATMSelect
              name="requestStatus"
              value={values?.requestStatus}
              label="Status"
              placeholder="Select Status"
              options={StatusOptions}
              onChange={(newValue) => setFieldValue("requestStatus", newValue)}
              onBlur={handleBlur}
            />
          </div>
          <div>
          <ATMCheckbox
          name="isShowMarkSpam"
            label="Is-Spam"
            checked={values?.isShowMarkSpam}
            onChange={(checked) => {
              setFieldValue('isShowMarkSpam' , checked )
            }}
          />
          </div>
        </div>
        <div>
          <ATMSelect
            name="batch"
            value={values?.batch}
            isLoading={isDataLoading}
            label="Batches"
            placeholder="Select Batch"
            options={batchOptions}
            onChange={(newValue) => setFieldValue("batch", newValue)}
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMSelect
            name="actionBy"
            value={values?.actionBy}
            isLoading={isLoading || isFetching}
            label="Action By"
            placeholder="Select Action By"
            options={memebersOptions}
            onChange={(newValue) => setFieldValue("actionBy", newValue)}
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          className="border  font-medium w-full rounded p-2 h-[42px] flex gap-2 justify-center items-center bg-slate-200 hover:bg-slate-300"
          onClick={onClose} // Call onClsoe when clicked the button
        >
          Close
        </button>
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          onClick={() => {
            handleSubmit();
          }}
        >
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default FilterDialogForm;
